import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';

import { useCustomSnackbar } from '../../hooks/useCustomSneakbar';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';



const ViewAllStudent = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection()

    const [TeacherList, setTeacherList] = useState([])
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const [openSuccessSnackbar] = useCustomSnackbar('success')


    useEffect(() => {

        getTeacherData()

    }, []);

    const getTeacherData = ()=>{
        const apiUrl = `/students?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setTeacherList(response.data.result)
                console.log('Data:', response.data);
            })
            .catch(error => {
                // Handle any errors that occurred during the request
                console.error('Error fetching data:', error);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                   
            });
    }

    return (
        <>
            {/* <SectionSidebar /> */}
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item">
                                <span>Home</span>
                            </li>
                            
                            <li className="breadcrumb-item active"><span>View All Student</span></li>
                        </ol>
                    </nav>
                <div className="body flex-grow-1 px-3">
                    <div className="container-lg">
                        <div className="row">
                                    <h2>View All Student</h2>
                                    <p>
                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col"  className='sl_no'>Sr. No.</th>
                                                        <th scope="col"> Name</th>
                                                        <th scope="col"> Contact Number</th>
                                                        <th scope="col"> Email</th>
                                                        <th scope="col"> Gender</th>
                                                        <th scope="col"> Qualification</th>
                                                        {/* <th scope="col">Action</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        TeacherList.length > 0 ?
                                                            TeacherList.map((teacher, index) => {
                                                                return (
                                                                    <tr>
                                                                        <th scope="row"  className='sl_no'>{index + 1}</th>
                                                                        <td>{teacher.teacherName}</td>
                                                                        <td>{teacher.contactNumber}</td>
                                                                        <td>{teacher.email}</td>
                                                                        <td>{teacher.gender}</td>
                                                                        <td>{teacher.qualification}</td>

                                                                        {/* <td>
                                                                            <button className="btn btn-success approve_icon" type="button" onClick={() => {
                                                                               
                                                                                updateLesson(teacher.id)
                                                                            }}>Approve</button>
                                                                            <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteLesson(teacher.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                        </td> */}
                                                                    </tr>
                                                                )
                                                            })
                                                            :
                                                            (<tr>
                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Student Available</th>

                                                            </tr>)
                                                    }

                                                </tbody>
                                            </table>
                                        </div>
                                    </p>
                            

                        </div>

                    </div>
                </div>

                <div className="col-md-12 mt-4">  </div>



            </div>
            <Footer />
        </>
    )
};

export default ViewAllStudent;